import { useAppTranslation } from "./useAppTranslation";
import { SUPPORTED_LANGUAGES } from "./types";
import type { SupportedLanguage } from "./types";

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage, t } = useAppTranslation();

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="language-select" className="text-sm font-medium">
        {t("language.label")}
      </label>
      <select
        id="language-select"
        value={currentLanguage}
        onChange={(e) => changeLanguage(e.target.value as SupportedLanguage)}
        className="bg-background focus:ring-ring rounded-md border px-3 py-1.5 text-sm focus:ring-2 focus:outline-none"
        aria-label={t("language.label")}
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.nativeName}
          </option>
        ))}
      </select>
    </div>
  );
}
